import * as _4 from 'lodash4';
import { MajorExplorerCapabilityConfiguration } from '../../configuration';
import { MajorSearchService } from '../../data/services/major_search_service';

export class MajorSearchViewContentController {
  constructor(
    private $state: ng.ui.IStateService,
    private ngMajorSearchService: MajorSearchService,
    private ngMajorExplorerCapabilityConfiguration: MajorExplorerCapabilityConfiguration
  ) {}

  goBack(): void {
    this.ngMajorSearchService.reset();
    this.$state.go('my.survey');
  }

  search(): () => void {
    return this.ngMajorSearchService.setSearch();
  }

  private hasSearchQuery(): boolean {
    return !_4.isEmpty(this.ngMajorSearchService.query);
  }

  doesNotHaveResults(): boolean {
    return !this.hasNotSearched() && !this.ngMajorSearchService.hasSearchResults;
  }

  hasNotSearched(): boolean {
    return !this.ngMajorSearchService.searchedPerformed && !this.hasSearchQuery();
  }

  isMobile(): boolean {
    return this.ngMajorExplorerCapabilityConfiguration.config.isMobile;
  }
}

export class MajorSearchViewContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/major_search_view_content/major_search_view_content.html';
  public controller: any = MajorSearchViewContentController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/major_search_view_content/major_search_view_content_controller.ts